export default __webpack_public_path__ + "static/media/1279.707beb7d.jpg";